let $api;

$api = (service, params) => {
  const services = {
    // Event Admin
    post_event_admin_login: "/api/v1/event/login/",
    post_event_create: "/api/v1/event/create/",
    get_event_dashboard: "/api/v1/event/dashboard/",
    get_event_details: "/api/v1/event/details/{slug}/",
    patch_event_update: "/api/v1/event/details/{slug}/",
    get_event_registrations: "/api/v1/event/details/{slug}/registrations/",
    get_event_registrations_export:
      "/api/v1/event/details/{slug}/registrations/export/",
    post_event_toggle_active: "/api/v1/event/details/{slug}/toggle-active/",
    post_event_admin_refresh_token: "/api/v1/event/refresh/",

    // Event Public
    get_event_details_public: "/api/v1/event/public/{slug}/",
    post_event_register_via_email: "/api/v1/event/register/{slug}/email/",
    post_event_registration_via_social: "/api/v1/event/register/{slug}/oauth/",
    get_event_registration_prefill:
      "/api/v1/event/register/{slug}/prefill/?token={token}",
    post_event_registration_complete: "/api/v1/event/register/{slug}/complete/",

    // Settings
    invoices: "/api/v1/invoices",
    invoices_pdf: "/api/v1/invoices/{id}/pdf",
    download_profile_pdf: "/api/v1/user/profile/pdf/",
    about_us: "/api/v1/settings/about-us/",
    help_faqs: "/api/v1/settings/help-faqs/",
    help_faqs_details: "/api/v1/settings/help-faqs/{id}/",
    terms_and_privacy: "/api/v1/settings/terms-and-privacy/",
    post_deactivate_otp_email: "/api/v1/user/send-deactivate-account-otp/",
    post_delete_otp_email: "/api/v1/user/send-delete-account-otp/",
    delete_user: "/api/v1/user/delete/",
    deactivate_user: "/api/v1/user/deactivate/",
    deactivate_all_device_tokens: "/api/v1/user/device-tokens/deactivate-all/",
    user_set_password: "/api/v1/user/set-password",

    // Additional libraries
    country_data_by_ip: "https://ipapi.co/json/",

    // For development
    image_url: process.env.REACT_APP_API_URL,

    // Social auth apis
    google: "/api/v1/user/auth/google/",
    linkedin: "/api/v1/user/auth/linkedin/",
    linkedin_client: process.env.REACT_APP_LINKEDIN_CLIENT_ID,

    // USER ENDPOINTS
    user_register_phone: "/api/v1/user/register/",
    user_re_activate: "/api/v2/user/reactivate/",
    user_new_email_send_otp: "/api/v1/user/send-update-email-otp/",
    user_confirm_new_email_otp: "/api/v1/user/confirm-update-email-otp/",
    user_register_email: "/api/v3/user/register/",
    user_register_confirmation: "/api/v1/user/confirm-registration/",
    user_register_confirmation_v2: "/api/v2/user/confirm-registration/",
    user_register_resend_otp: "/api/v1/user/register/resend-otp/",
    user_register_resend_otp_v2: "/api/v2/user/register/resend-otp/",
    send_reset_password_otp: "/api/v1/user/send-reset-password-otp/",
    user_register_activate_user: "/api/v1/user/activate-user/",
    user_send_reset_password_otp: "/api/v1/user/send-reset-password-otp/",
    user_send_reset_password_otp_v2: "/api/v2/user/send-reset-password-otp/",
    user_set_new_password: "/api/v1/user/set-new-password/",
    user_set_new_password_v2: "/api/v2/user/set-new-password/",
    user_confirm_reset_password: "/api/v1/user/confirm-reset-password-otp/",
    user_confirm_reset_password_v2: "/api/v2/user/confirm-reset-password-otp/",
    user_change_password: "/api/v1/user/change-password/",
    user_update_multiple: "/api/v1/user/update/",
    user_update_single: "/api/v1/user/update/",
    user_get: "/api/v1/user/",
    get_me_subscription: "/api/v1/me/subscription/",
    user_login: "/api/v1/user/login/",
    user_login_v2: "/api/v2/user/login/",
    user_get_profile: "/api/v1/user/profile/",
    user_update_profile: "/api/v1/user/profile/",
    user_refresh_token: "/api/v1/user/refresh/",

    // PROFILE ENDPOINTS
    profile_detail_by_username: "/api/v1/profile/{username}/",
    profile_update: "/api/v1/user/profile/",
    profile_detail_by_id: "/api/v1/profiles/id/{id}/",
    profile_detail_delete_by_id:
      "/api/v1/user/profile/delete/{field_name}/{id}",
    send_verify_extra_phone_number_otp:
      "/api/v1/profile/send-verify-extra-phone-number-otp/",
    confirm_verify_extra_phone_number_otp:
      "/api/v1/profile/confirm-verify-extra-phone-number-otp/",
    confirm_verify_extra_email_otp:
      "/api/v1/profile/confirm-verify-extra-email-otp/",
    confirm_verify_extra_emails: "/api/v1/profile/verify-extra-email/{id}/",
    post_verify_extra_emails: "/api/v1/profile/send-verify-extra-email-otp/",
    post_send_registration_whatsapp:
      "/api/v1/profile/send-registration-whatsapp/",

    // SEARCH ENDPOINTS
    search_profiles: "/api/v1/profiles/?limit={limit}&page={page}&q={keyword}",
    save_search: "/api/v1/profile/save-search/",
    // PRE-REGISTER ENDPOINTS
    pre_register: "/api/v1/pre-register",

    // PRICING ENDPOINTS
    pricing: "/api/v1/plans",

    // SUBSCRIPTION
    subscribe_plan: "/api/v1/subscriptions",
    cancel_subscription: "/api/v1/subscriptions/deactivate/",

    // Trial
    free_trial: "/api/v1/start-free-trial/",

    // ORDER BUCARD ENDPOINTS
    order_bucard_get_card_styles: "/api/v1/user/card-styles/",
    order_bucard_order_card: "/api/v1/user/order-card/",
    order_bucard_validate_card_order: "/api/v1/user/validate-order/",

    // CORE ENDPOINTS
    professions_all_list:
      "/api/v1/professions?limit={limit}&page={page}&name={name}",
    languages_all_list:
      "/api/v1/languages?name={name}&limit={limit}&offset={offset}",
    get_url_meta_data: "/api/v1/featured-links/fetch-metadata",
    skills_all_list: "/api/v1/skills?limit={limit}&page={page}&title={title}",
    keywords_all_list:
      "/api/v1/keywords?limit={limit}&page={page}&title={title}",

    // BOXES ENDPOINTS
    boxes_get_all: "/api/v1/boxes",
    boxes_create: "/api/v1/boxes",
    boxes_get_details: "/api/v1/boxes/{id}/profiles?limit={limit}&page={page}",
    other_box_persons: "/api/v1/boxes/other-box-persons/{id}",
    search_profile_in_box: "/api/v1/boxes/{box_id}/profiles?q={query}&page={page}&limit={limit}",
    boxes_delete: "/api/v1/boxes/{id}",
    boxes_add_profile: "/api/v1/boxes/{id}/add_profile",
    boxes_remove_profile: "/api/v1/boxes/{id}/remove_profile",
    boxes_remove_profile_from_all_boxes:
      "/api/v1/boxes/remove_profile_from_all",
    boxes_edit: "/api/v1/boxes/{id}/update_box",
    // boxes_move: "/api/v1/boxes/{id}/add_profile",
    boxes_move: "/api/v1/boxes/move_between_boxes",
    // PLAN ENDPOINTS
    plan_get_all: "/api/v1/plans",

    // Bonus Stystem
    get_bonuce_balance: "/api/v1/bonus/balance/",
    get_bonuce_transactions: "/api/v1/bonus/transactions/?page={page}&limit={limit}",
    get_bonuce_rules_detail: "/api/v1/bonus/rules-detail/",
    post_spend_bonuce_balance: "/api/v1/bonus/spend/",

    // API Keys from environment variables (NEVER hardcode these!)
    google_map_browser_key: process.env.REACT_APP_GOOGLE_MAP_BROWSER_KEY,
    google_map_server_key: process.env.REACT_APP_GOOGLE_MAP_SERVER_KEY,
    google_map_develop: process.env.REACT_APP_GOOGLE_MAP_PRODUCTION_KEY,
    google_map_production: process.env.REACT_APP_GOOGLE_MAP_PRODUCTION_KEY,
    google_client: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    youtube_api_key: process.env.REACT_APP_YOUTUBE_API_KEY,
    sentry_dsn: process.env.REACT_APP_SENTRY_DSN,

    // Notifications
    notifications_list: "/api/v1/notifications/",
    notifications_details: "/api/v1/notifications/{id}/",
    notifications_stats: "/api/v1/notifications/stats/",
    notifications_mark_read: "/api/v1/notifications/mark-read/",
    notifications_mark_all_read: "/api/v1/notifications/mark-all-read/",
    notifications_unread_count: "/api/v1/notifications/unread-count/",

    // Firebase
    firebase_config: "/api/v1/firebase/config/",
    firebase_health: "/api/v1/firebase/health/",
    firebase_test_notification: "/api/v1/firebase/test-notification/",

    // Apps download urls
    ios_app_url: "https://apps.apple.com/az/app/bucard/id6478505117",
    android_app_url:
      "https://play.google.com/store/apps/details?id=bucard.tech",
  };
  if (!services[service]) {
    return "";
  }

  if (typeof services[service] === "string") {
    services[service] = { path: String(services[service]) };
  }

  let url = services[service]?.path || "";
  if (params) {
    let query_params = {};
    let has_query_params = false;

    for (const [key, value] of Object.entries(params)) {
      let replaced = false;
      url = url.replaceAll("{" + key + "}", () => {
        replaced = true;
        return value;
      });
      if (!replaced) {
        has_query_params = true;
        query_params[key] = value;
      }
    }

    if (has_query_params) {
      let param = new URLSearchParams(query_params);
      url += "?" + param.toString();
    }
  }
  url = url.replaceAll("{lang}", "");

  return url;
};

export { $api };
